﻿
import {ResponseApi} from "../../Model/ResponseApi.js";
import {ITemplateListeItemModel, ITemplateModel} from "../../Model/Template/ITemplateModel.js";
import {TypeProcessEnum} from "../../Variables/TypeProcessEnum.js";
import {TypeContentEnum} from "../../Variables/TypeContentEnum.js";
import {ITemplateFilterModel} from "../../Model/FilterModel/TemplateFilterModel.js";
import {JsonFetchJson} from "../../Helper/FetchHelper.js";

export class TemplateRead {
        public static Read = async (filter: ITemplateFilterModel) => {
            return JsonFetchJson.Post<ResponseApi<Array<ITemplateModel>>>("/template", filter)
                .then(response => {
                    response.Data.forEach(x => {
                        x.TypeContentLibelle = TypeContentEnum.Instance.GetLibelle(x.TypeContent);
                        x.TypeProcessLibelle = TypeProcessEnum.Instance.GetLibelle(x.TypeProcess);
                    });
                    return response.Data;
                });
        }

        public static ReadList = async (filter: ITemplateFilterModel) => {
            return JsonFetchJson.Post<ResponseApi<Array<ITemplateListeItemModel>>>("/template/liste", filter)
                .then(response => {
                    return response.Data
                });
        }
    }
